import { PageContexts } from '@/addons/enums'
interface LoaderInterface {
  section: PageContexts
  loaderOnTop?: boolean
  loaderSolidBg?: boolean
  loaderAnimation?: boolean
}
export default abstract class LoaderController {
  // Track concurrent callers to avoid premature hide when multiple flows are loading
  private static activeCount = 0

  static show(loaderOptions: LoaderInterface) {
    LoaderController.activeCount += 1

    const loaderDiv = document.getElementById('pageloader-container')
    const loader = document.getElementById('pageloader')
    const isFirstShow = LoaderController.activeCount === 1

    if (loaderOptions.loaderOnTop) {
      document.body.classList.add('loader-on-top')
    }
    if (loaderOptions.loaderSolidBg) {
      loaderDiv?.classList.add('solid-bg')
    }
    if (!loaderOptions.loaderAnimation) {
      loaderDiv?.classList.add('no-animation')
    } else {
      loaderDiv?.classList.remove('no-animation')
    }
    if (loader) {
      loader.className = ''
      loader?.classList.add(loaderOptions.section.toLowerCase())
    }
    if (isFirstShow) {
      loaderDiv?.classList.add('show')
      loaderDiv?.classList.remove('hide')
    }
  }

  static hide(options: { force?: boolean } = {}) {
    // Allow a forced hide to clear any pending counters (useful after navigation)
    if (options.force) {
      LoaderController.activeCount = 0
    } else {
      if (LoaderController.activeCount === 0) {
        return
      }
      LoaderController.activeCount = Math.max(
        0,
        LoaderController.activeCount - 1,
      )
      if (LoaderController.activeCount > 0) {
        return
      }
    }

    const loaderDiv = document.getElementById('pageloader-container')
    const loader = document.getElementById('pageloader')
    const loaderOnTop = document.body.classList.contains('loader-on-top')
    if (loaderOnTop) {
      document.body.classList.remove('loader-on-top')
    }
    if (loaderDiv) {
      loaderDiv.classList.add('hide')
      loaderDiv.classList.remove('show')
    }

    // wait for the css keyframe fadeOut animation to remove loader class
    const i = setInterval(function () {
      if (loader) {
        loader.className = ''
      }
      clearInterval(i)
    }, 1000)
  }
}
